const getFileName = path => {
  const split_path = path.split('\\');
  return split_path[split_path.length - 1];
};

export default getFileName;
